import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {};

export const box: SxStyle = {
  gap: (p) => p.spacing(1.5),
  width: '100%',
};
